import { render } from "./NewSignIns.vue?vue&type=template&id=09ddcb00"
import script from "./NewSignIns.vue?vue&type=script&lang=js"
export * from "./NewSignIns.vue?vue&type=script&lang=js"

import exportComponent from "/src/Hikarusa.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__